<template>
    <navigator-emulator />
</template>

<script>
import metaCheck from '@common/mixins/metaCheck'

export default {
    name: 'NavigatorDesigner',

    mixins: [
        metaCheck,
    ],
}
</script>
